module.exports = __webpack_public_path__ + "media/images/icon_nega1-776fd391abea82aec707227f9aa7f094.svg";